import axios from "axios";
import { api } from "../api/api";

export const getTemporaryUrl = async (fileUrl, AuthToken) => {
  const payload = {
    file: fileUrl,
  };
  let res = await api(
    `api/v1/course/getPresignedFile`,
    payload,
    "post",
    AuthToken,
    ""
  );

  if (res?.success) {
    console.log(res, res.url, "new vido");

    return res.data?.url;
  } else {
    return;
  }
};
